import { render, staticRenderFns } from "./Contenidos.vue?vue&type=template&id=14c0e6dd&"
import script from "./Contenidos.vue?vue&type=script&lang=js&"
export * from "./Contenidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Contenidos.vue"
export default component.exports